module.exports = __webpack_public_path__ + "static/media/mahlzeiten_pattern.08ea7e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mahlzeiten_pattern.png
// module id = 118
// module chunks = 0